<template>
  <div
    :class="`divider divider--direction-${direction} divider--color-${color}`"
    role="separator"
    :aria-orientation="direction"
  />
</template>

<script lang="ts">
export default {
  name: 'Divider',
}
</script>

<script setup lang="ts">
withDefaults(
  defineProps<{
    direction?: 'horizontal' | 'vertical'
    color?: 'default' | 'subdued'
  }>(),
  {
    direction: 'horizontal',
    color: 'default',
  },
)
</script>

<style scoped lang="scss">
.divider {
  &--direction-horizontal {
    width: 100%;
    height: 1px;
  }

  &--direction-vertical {
    width: 1px;
    height: 100%;
  }

  &--color-default {
    background-color: var(--color-border-input);
  }

  &--color-subdued {
    background-color: var(--color-border-default);
  }
}
</style>
